import Store from "@/store";
import axios from "axios";

export default {
    path: '/check-order',
    name: 'Check-Order',
    component: () => import('@/views/check_order/index.vue'),
    meta: {
        title: 'Проверка заказов',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {

        let code = to.query.code

        if(code) {
            next()
        } else {
            let token = Store.getters['auth/token']
            let phone = Store.getters['auth/phone']

            if(token && phone) {
                let checkToken = await axios.post('/checkTocken', { tocken: token })
                checkToken.data ? next() : next({name: 'Auth-Check-Order'})
            } else {
                next({name: 'Auth-Check-Order'})
            }
        }
    }
}